
import serverAxiosInstance from '../Backend'

export const deleteOneMe = async (notificationId) => {
    await serverAxiosInstance.delete(`/api/v2/notifications/${notificationId}/users/me`)
}

export const updateOneMe = async (notificationId, notificationUpdateObj) => {
    await serverAxiosInstance.patch(`/api/v2/notifications/${notificationId}/users/me`,notificationUpdateObj)
}

export const insertOneMe = async (notificationObj) => {
    await serverAxiosInstance.post(`/api/v2/notifications/users/me`,notificationObj)
}

